module.exports = __webpack_public_path__ + "img/LSK.e4b71f04.svg";